// TODO: Remove the any type and replace with a proper type.
import { Component } from '@angular/core';
import type { OnInit } from '@angular/core';
import { NavParams, ModalController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import type { TRouteLeg, TTicket } from '@shared/models';

@Component({
    'selector': 'app-ticketsModal',
    'templateUrl': './ticketsModal.page.html',
    'styleUrls': ['./ticketsModal.page.scss'],
    'standalone': true,
    imports: [IonicModule, CommonModule, FormsModule]
})
export class TicketsModalPage implements OnInit {
    public vm: any = {};
    public assignedTickets = [];
    public enrouteTickets = [];
    public currentTickets = [];
    public completedTickets = [];

    constructor(public modalController: ModalController, public navParams: NavParams) {
    }

    public ngOnInit(): void {
        this.vm = this.navParams.get('vm');

        this.assignedTickets = this.vm.assignedTickets || [];
        this.enrouteTickets = this.vm.enrouteTickets || [];
        this.currentTickets = this.vm.currentTickets || [];
        this.completedTickets = this.vm.completedTickets || [];
    }

    public getType(ticket: TTicket) {
        const type = (ticket.fromDealership ? 'Dropoff' : 'Pickup');
        return type;
    }

    public getToAddress(ticket): string {
        const ticketUid = ticket.uid;
        const leg = this.vm.route.routeLegs.find((leg2: TRouteLeg) => (leg2.ticketUid === ticketUid));
        if (!leg) {
            return 'error: no ticket found.';
        }
        return leg.to.address;
    }

    public async onCancelClick() {
        await this.modalController.dismiss(null);
    }
}
